import { render, staticRenderFns } from "./BaseLoadingContainer.vue?vue&type=template&id=c15f9112"
import script from "./BaseLoadingContainer.vue?vue&type=script&lang=js"
export * from "./BaseLoadingContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports